import React from 'react';
import './Climb.css';

const Climb = () => {
    return (
        <div className="climb__wrapper">
            <div className="container">
                <div className="box">
                    <div className="cube"></div>
                </div>
            </div>
        </div>
    )
}

export default Climb
